<script>
import Routable from "@mixins/routable";
import LuminanceMask from "@/components/ui/masks/LuminanceMask";

export default {
  name: "CityButton",
  mixins: [Routable],
  computed: {
    classes() {
      return ["city-button", Routable.computed.classes.call(this)];
    }
  },
  render(h) {
    const { tag, data } = this.generateRouteLink();

    const content = (
      <div>
        <LuminanceMask
          class="city-button__bg-small"
          src={require("@/assets/images/city/btn-bg-small.jpg")}
        />
        <LuminanceMask
          class="city-button__bg"
          src={require("@/assets/images/city/btn-bg.jpg")}
        />
        <div class="city-button__content">{this.$slots.default}</div>
      </div>
    );

    return h(tag, data, [content]);
  }
};
</script>

<style lang="scss">
$p: ".city-button";

.city-button {
  color: colors(palette-2);
  width: 100%;
  max-width: 420px;
  display: flex;
  align-items: center;
  height: 83px;
  position: relative;
  z-index: 1;
  padding: 5px 25px;
  letter-spacing: -0.05em;
  font-size: 40px;

  &__content {
    color: colors(text-3);
    text-transform: uppercase;
    font-weight: fw(bold);
  }

  &__bg,
  &__bg-small {
    position: absolute;
    transition: color 0.2s;
  }

  &__bg {
    top: 0;
    left: 0;
    color: colors(text-2);
    width: 420px;
    height: 83px;
    z-index: -1;
    max-width: 100%;
  }

  &__bg-small {
    top: -10px;
    left: -10px;
    color: colors(text-4);
    width: 273px;
    height: 105px;
    z-index: -2;
    max-width: 70%;
  }

  &:hover {
    text-decoration: none;
    #{$p}__bg {
      color: colors(text-4);
    }
    #{$p}__bg-small {
      color: colors(text-2);
    }
  }

  &:active {
    #{$p}__bg-small {
      color: colors(text-4);
    }
  }

  @include breakpoint("md-and-down") {
    margin: 0 auto;
  }

  @include breakpoint("xs-only") {
    padding: 0 20px;
    font-size: 28px;
  }
}
</style>
